import { TEXTS } from './texts';

export const NOTIFICATION_DEFAULT_DELAY = 5000;
export const NOTIFICATION_DEFAULT_ERROR_MESSAGE = TEXTS.NOTIFICATION_DEFAULT_ERROR_MESSAGE;
export const NOTIFICATION_DEFAULT_SUCCESS_MESSAGE = TEXTS.NOTIFICATION_DEFAULT_SUCCESS_MESSAGE;
export const NOTIFICATION_DEFAULT_INFO_MESSAGE = TEXTS.NOTIFICATION_DEFAULT_INFO_MESSAGE;
export const NOTIFICATION_DEFAULT_WARNING_MESSAGE = TEXTS.NOTIFICATION_DEFAULT_WARNING_MESSAGE;

export const SWAP_DELAY = 500;
